import { Injectable } from '@angular/core';
import * as signalR from "@aspnet/signalr";
// import { ChartModel } from '../_interfaces/chartmodel.model';
 
@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private hubConnection: signalR.HubConnection
 
  public startConnection = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
                            .withUrl('https://shikmapro.co.il/parkingHub')
                            .build();
 
    this.hubConnection
      .start()
      .then(() => console.log('Connection started'))
      .catch(err => console.log('Error while starting connection: ' + err))

    this.hubConnection.on('test', () => {
      console.log("TCL: SignalRService -> test")
    });
  }

}